import {
  EditOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { Button, Form, Space, Tooltip } from 'antd'
import dayjs from 'dayjs'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import { hasPermission } from '../../config-func'
import {
  ACTION_MODE,
  OPTIONS_ROLE,
  OPTIONS_STATUS_NOTIFICATION,
  PAGE_SIZE_OPTIONS
} from '../../configData'
import {
  departmentSearch,
  getNotificationManager,
  notificationDetail,
  notificationManagerAdd,
  notificationManagerUpdate,
  notificationStatus
} from '../../services/cmsservice'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import Loading from '../Loading';
const NotificationManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const [listDepartment, setListDepartment] = useState([])
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      title: filters.title || '',
      status: filters.status || '',
      start_date:
        (filters?.date && dayjs(filters?.date[0], 'DD/MM/YYYY').valueOf()) ||
        '',
      end_date:
        (filters?.date && dayjs(filters?.date[1], 'DD/MM/YYYY').valueOf()) || ''
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getNotificationManager(cleanedData)
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification('error', error?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])

  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Tiêu đề',
      dataIndex: 'title',
      key: 'title',
      width: 150,
    },
    {
      title: 'Nội dung',
      dataIndex: 'content',
      key: 'content',
      width: 150,
    },
    {
      title: 'Thời gian gửi',
      dataIndex: 'date_sent',
      key: 'date_sent',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.date_sent
            ? dayjs(record.date_sent).format('HH:mm:ss DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    {
      title: 'Chức danh',
      dataIndex: 'permission',
      key: 'permission',
      width: 150,
      render: (_, record) => {
        try {
          const permissions = JSON.parse(record.permission || '[]')
          const permissionNames = permissions.map(permission => {
            const role = OPTIONS_ROLE.find(item => item.value === permission)
            return role ? role.name : permission
          })
          return permissionNames.join(', ') || ''
        } catch (error) {
          return ''
        }
      }
    },
    // { title: 'Quản lý TP', dataIndex: 'name', key: 'name' },

    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      render: (_, record, index) => {
        const name = OPTIONS_STATUS_NOTIFICATION.find(
          (n) => n.value === record.status
        )?.name
        return <span>{name}</span>
      }
    },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {record.status == 1 && (
              <Tooltip title="Xem chi tiết">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.VIEW)
                    getDetailNotification(record.id)
                  }}
                />
              </Tooltip>
            )}
            {record.status == 0 && (
              <>
                <Tooltip title="Chỉnh sửa">
                  <Button
                    style={{ width: 32 }}
                    icon={<EditOutlined />}
                    onClick={() => {
                      setMode(ACTION_MODE.UPDATE)
                      getDetailNotification(record.id)
                    }}
                  />
                </Tooltip>

                <Tooltip title="Hủy">
                  <Button
                    // style={{ width: 32 }}
                    // icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận hủy',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn hủy
                            {/* <b> {record.project_name}</b> không? */}
                          </div>
                        ),
                        onOk: () => handleChangeStatus(2, record.id)
                      })
                    }
                  >
                    {' '}
                    Hủy
                  </Button>
                </Tooltip>
              </>
            )}
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, ...data } = values
      const res =
        mode == ACTION_MODE.ADD
          ? await notificationManagerAdd(data)
          : await notificationManagerUpdate(data, id)

      form.resetFields()
      setIsModalOpen(false)
      fetchData()
      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo mới thông báo thành công !'
          : 'Cập nhật thông báo thành công !'
      )
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  // Chi tiết dự án
  const getDetailNotification = async (id) => {
    setLoading(true)
    try {
      const res = await notificationDetail(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data
        const normalizedValue =
          values.departments_id === '""' ? '' : Number(values.departments_id)

          form.setFieldsValue({
          ...values,
          date_sent: dayjs(values.date_sent),
          departments_id: normalizedValue,
          permission: JSON.parse(values.permission),
          users_id: JSON.parse(values.users_id)
        })
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const getDepartmentAll = async () => {
    const type = ''
    const body = { type, page: 1, pageSize: 1000 }
    try {
      const res = await departmentSearch(body)
      const updatedData = res?.data?.list?.map((item) => ({
        ...item,
        label: item.name,
        value: item.id
      }))
      setListDepartment(updatedData)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  useEffect(() => {
    getDepartmentAll()
  }, [])

  const handleChangeStatus = async (status, id) => {
    try {
      const res = await notificationStatus(status, id)
      if (res && res.data) {
        openNotification('success', 'Cập nhật thành công')
        fetchData()
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        

        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
      <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý dự án</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {/* <Button
              type="primary"
              key="primary"
              onClick={() => {
                setIsModalImportOpen(true)
              }}
            >
              <PlusOutlined /> Import Excel
            </Button> */}
            {hasPermission('P45.1', permissions) && (
            <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                setIsModalOpen(true)
                setMode(ACTION_MODE.ADD)
              }}
            >
              <PlusOutlined />
              Thêm mới
            </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          // locale={{
          //   emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
          //   triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
          //   triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
          //   cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          // }}

          // columns={
          //   filters.isDefault === 'fixed'
          //     ? columns.filter(
          //         (item) => !['calculationMethod'].includes(item.dataIndex)
          //       )
          //     : columns.filter(
          //         (item) => !['isDefault'].includes(item.dataIndex)
          //       )
          // }

          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa thông báo'
            : mode == 'ADD'
            ? 'Thêm mới thông báo'
            : 'Xem chi tiết'
        }
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={mode == 'VIEW' ? [''] : ''}
      >
        <FormPost
          form={form}
          handleSearch={handleSearch}
          listDepartment={listDepartment}
          mode={mode}
        />
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default NotificationManagement
